import abeer1 from '../../Assets/Projects/Abeer/abeer-1.png'
import astitva1 from '../../Assets/Projects/Astiitva/astitva-1.png'
import abeerLogo from '../../Assets/Abeerlogo.png'
import astitvaLogo from '../../Assets/astitva-logo.png'
import MritkalaLogo from "../../Assets/MritkalaLogo.png"
import mritkala1 from '../../Assets/community3.jpg'

const data = [
    {
        // index : 1,
        name : "abeer",
        content : `Project Abeer is an initiative to overcome the problems caused by chemical loaded soaps, to curb the use of plastic and to concurrently generate employment for underprivileged women. We bring to you indigenous organic alternatives for chemical infused soaps, which are not only good for your skin but also for the environment.  `,
        pageLink: "/projects/abeer",
        showStore: true,
        showMagazine: false,
        image: abeer1,
        logo: abeerLogo,
    },
    {
        // index : 2, 
        name : "astitva",
        content: "Astitva is an initiative taken to provide a platform to empower various stakeholders highly concerned about the social evils of the society. It can help in creating a sense of awareness among individuals and organizations about current challenges faced by our society. It provides an opportunity for Enactus ADGITM itself to be involved in identification of social problems at ground level.",
        pageLink: "/projects/astitva",
        showStore: false,
        showMagazine: true,
        image: astitva1,
        logo: astitvaLogo,
    },
    {
        //index:3
		name : "Mritkala",
        content: "Project Mritkala, is an enterprise under Enactus ADGITM, that intends to acquaint the society with the revamped trend of pottery. Our aim is to succour the artisans who possess the artistry of moulding clay into alluring handcrafted resilient pieces of craftsmanship.",
        pageLink: "/projects/mritkala",
        showStore: true,
        showMagazine: false,
        image: mritkala1,
        logo: MritkalaLogo,
    },
]

export default data